const PARTNERS = [
  { name: "Ampra Systems", icon: "ri-building-4-line" },
  { name: "NorthGrid Networks", icon: "ri-router-line" },
  { name: "SafeWatch Security", icon: "ri-shield-check-line" },
  { name: "FireGuard Solutions", icon: "ri-fire-line" },
  { name: "MetroFiber Co.", icon: "ri-broadcast-line" },
  { name: "Vertex IT Group", icon: "ri-server-line" },
];

export default function TrustBar() {
  return (
    <section className="relative bg-background-100 border-y border-background-200 py-8 md:py-10">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
          <div className="shrink-0 text-center lg:text-left">
            <p className="text-xs font-mono uppercase tracking-[0.24em] text-foreground-500">
              Our graduates work at
            </p>
            <p className="text-sm md:text-base font-heading font-semibold text-foreground-900 mt-1">
              Companies actively hiring tech-savvy techs
            </p>
          </div>
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-4 sm:gap-x-6 gap-y-3 sm:gap-y-4">
            {PARTNERS.map((p) => (
              <div
                key={p.name}
                className="flex items-center gap-2 text-foreground-600 hover:text-foreground-900 transition-colors overflow-hidden"
              >
                <i className={`${p.icon} text-lg text-primary-500 shrink-0`} aria-hidden="true"></i>
                <span className="text-sm font-semibold truncate">{p.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}